import React from 'react';
import * as THREE from 'three';

export const Floor = () => {
  // Create plane geometry
  const planeGeometry = new THREE.PlaneGeometry(1000, 1000);
  
  return (
    <group position={[0, 0, 0]}>
      {/* Back plane */}
      <mesh 
        geometry={planeGeometry} 
        position={[0, -1, -4.4]} 
        receiveShadow
      >
        <meshStandardMaterial color="#fff" />
      </mesh>
      
      {/* Floor plane */}
      <mesh 
        geometry={planeGeometry} 
        position={[0, -1, -1]} 
        receiveShadow 
        rotation={[Math.PI + Math.PI / 12, 0, 0]}
      >
        <meshStandardMaterial color="#fff" />
      </mesh>
      
      {/* Grid helper */}
      <gridHelper 
        rotation={[Math.PI / 12, 0, 0]} 
        position={[0, 1, -10]} 
        args={[25, 15, '#999', '#999']} 
      />
    </group>
  );
};